import React from 'react'
import {Polygon} from 'react-leaflet'
import {connect} from 'react-redux'

const Boundaries = ({showBoundaries, boundaries, ...props}) => {
  if(!showBoundaries) {
    return null
  }
  return <Polygon positions={boundaries} {...props}/>
}

const mapStateToProps = state => ({
  showBoundaries: state.show.boundaries,
  boundaries: state.boundaries,
})

export default connect(mapStateToProps)(Boundaries)



/** WEBPACK FOOTER **
 ** ./app/components/Boundaries.jsx
 **/